class CartProgressBar extends HTMLElement {
  connectedCallback() {
    this.free_gift_exist_1 = this.getAttribute('data-free-gift-exist-1');
    this.free_gift_variant_id_1 = this.getAttribute('data-free-gift-variant-id-1');
    this.free_gift_threshold_1 = Number(this.getAttribute('data-free-gift-threshold-1'));
    this.free_gift_line_key_1 = this.getAttribute('data-free-gift-line-key-1');
    
    this.free_gift_exist_2 = this.getAttribute('data-free-gift-exist-2');
    this.free_gift_variant_id_2 = this.getAttribute('data-free-gift-variant-id-2');
    this.free_gift_threshold_2 = Number(this.getAttribute('data-free-gift-threshold-2'));
    this.free_gift_line_key_2 = this.getAttribute('data-free-gift-line-key-2');
    
    this.free_gift_exist_3 = this.getAttribute('data-free-gift-exist-3');
    this.free_gift_variant_id_3 = this.getAttribute('data-free-gift-variant-id-3');
    this.free_gift_threshold_3 = Number(this.getAttribute('data-free-gift-threshold-3'));
    this.free_gift_line_key_3 = this.getAttribute('data-free-gift-line-key-3');
    
    this.cartTotal = Number(this.dataset.cartTotal);

    this.evaluateFreeGift();

    document.addEventListener('cart:refresh', this.manageFreeGiftQuantity());
  }

  async manageFreeGiftQuantity() {
    if (this.free_gift_exist_1 === 'true' && this.free_gift_line_key_1) {
      console.log('here is manageFreeGiftQuantity 1');
      await this.modifyCart('modify', this.free_gift_variant_id_1, this.free_gift_line_key_1, 1);
    }
    if (this.free_gift_exist_2 === 'true' && this.free_gift_line_key_2) {
      console.log('here is manageFreeGiftQuantity 2');
      await this.modifyCart('modify', this.free_gift_variant_id_2, this.free_gift_line_key_2, 2);
    }
    if (this.free_gift_exist_3 === 'true' && this.free_gift_line_key_3) {
      console.log('here is manageFreeGiftQuantity 3');
      await this.modifyCart('modify', this.free_gift_variant_id_3, this.free_gift_line_key_3, 3);
    }
  }

  async evaluateFreeGift() {
    const qualifiesForGift1 = this.cartTotal >= this.free_gift_threshold_1 && this.free_gift_threshold_1 > 0;

    if (qualifiesForGift1 && !this.free_gift_line_key_1) {
      console.log('here is log 1-1');
      await this.modifyCart('add', this.free_gift_variant_id_1, this.free_gift_line_key_1, 1);
    } else if (!qualifiesForGift1 && this.free_gift_line_key_1) {
      console.log('here is log 1-2');
      await this.modifyCart('remove', this.free_gift_variant_id_1, this.free_gift_line_key_1, 1);
    }

    const qualifiesForGift2 = this.cartTotal >= this.free_gift_threshold_2 && this.free_gift_threshold_2 > 0;

    if (qualifiesForGift2 && !this.free_gift_line_key_2) {
      console.log('here is log 2-1');
      await this.modifyCart('add', this.free_gift_variant_id_2, this.free_gift_line_key_2, 2);
    } else if (!qualifiesForGift2 && this.free_gift_line_key_2) {
      console.log('here is log 2-2');
      await this.modifyCart('remove', this.free_gift_variant_id_2, this.free_gift_line_key_2, 2);
    }

    const qualifiesForGift3 = this.cartTotal >= this.free_gift_threshold_3 && this.free_gift_threshold_3 > 0;

    if (qualifiesForGift3 && !this.free_gift_line_key_3) {
      console.log('here is log 3-1');
      await this.modifyCart('add', this.free_gift_variant_id_3, this.free_gift_line_key_3, 3);
    } else if (!qualifiesForGift3 && this.free_gift_line_key_3) {
      console.log('here is log 3-2');
      await this.modifyCart('remove', this.free_gift_variant_id_3, this.free_gift_line_key_3, 3);
    }
  }

  async modifyCart(action, freeGiftVariantId, freeGiftKey, freeGiftIndex) {
    let endpoint = action === 'add' ? '/cart/add.js' : '/cart/change.js';
    let body = action === 'add'
      ? { id: freeGiftVariantId, quantity: 1, properties: { _isFreeGift: "true", _giftIndex: freeGiftIndex } }
      : { id: freeGiftKey, quantity: 0 };

    if (action === 'modify') {
      endpoint = '/cart/change.js';
      body = { id: freeGiftKey, quantity: 1 };
    }

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });

      if (!res.ok) throw new Error(`Cart ${action} failed`);

      if (action !== 'modify') {
        this.dispatchCartUpdated();
      }
    } catch (error) {
      console.error(`Failed to ${action} free gift:`, error);
    }
  }

  dispatchCartUpdated() {
   document.dispatchEvent(new CustomEvent('cart:refresh') );
  }
}

customElements.define('cart-progress-bar', CartProgressBar);